import Web3 from "web3";
import BigNumber from "bignumber.js";
import abi from '../../constants/abi';
import contracts from '../../constants/contracts';

export const buyNow = async (id,value,openConnectModal) => {
	try{
    const web3 = new Web3(window.ethereum);
  	const accounts = await web3.eth.getAccounts();
	const account = accounts[0];
    if (!account) await openConnectModal()
    const contract = new web3.eth.Contract(abi.MARKETPLACE, contracts.MARKETPLACE)
    const amountInWei = web3.utils.toWei(value.toString());

    var tx = await contract.methods
      .createMarketSale(id)
      .send({ from: account, value: amountInWei });
      console.log(`Transaction hash: ${tx.transactionHash}`);

    } catch(e){
        console.log(e)
    }
};
